var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserTypeSelector',{attrs:{"userTypeList":_vm.userTypeList,"currentUserTypes":_vm.selectedUserTypes,"isVisible":_vm.initialUserTypes.length > 1},on:{"userTypeChange":_vm.updateUserTypes}})
}
var staticRenderFns = []

export { render, staticRenderFns }